import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { addOrder } from '../services/firestoreService';
import { ShoppingBag, MapPin, Phone, Mail, User, CheckCircle } from 'lucide-react';
import NavBar from '../components/NavBar';

const Checkout = () => {
  const { cartItems, getTotal, clearCart } = useCart();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: currentUser?.displayName || '', phone: '', email: currentUser?.email || '', address: '', notes: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState('checkout');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!currentUser) navigate('/login');
  }, [currentUser, navigate]);

  useEffect(() => {
    if (currentPage === 'home') {
      navigate('/');
    } else if (currentPage === 'profile') {
      navigate('/profile');
    }
  }, [currentPage, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const orderData = { customerName: formData.name, customerPhone: formData.phone, customerEmail: formData.email, customerAddress: formData.address, notes: formData.notes, items: cartItems, total: getTotal(), type: 'multiple', status: 'pending' };
      const result = await addOrder(orderData);
      if (result.success) { setSuccess(true); clearCart(); setTimeout(() => navigate('/profile'), 2000); }
    } catch (error) { console.error('Order error:', error); } finally { setLoading(false); }
  };

  if (cartItems.length === 0 && !success) { navigate('/'); return null; }

  return (
    <div className="min-h-screen bg-gray-100">
      <NavBar currentPage={currentPage} setCurrentPage={setCurrentPage} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <div className="pt-24 px-4 pb-12">
        <div className="max-w-6xl mx-auto">
          {success ? (
            <div className="bg-white rounded-2xl shadow-xl p-12 text-center"><CheckCircle className="w-24 h-24 text-green-500 mx-auto mb-6" /><h2 className="text-3xl font-bold text-gray-900 mb-4">تم إرسال طلبك بنجاح!</h2><p className="text-gray-600 mb-6">سيتم التواصل معك قريباً</p></div>
          ) : (
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2"><div className="bg-white rounded-2xl shadow-xl p-8"><h2 className="text-2xl font-bold text-gray-900 mb-6">معلومات التوصيل</h2><form onSubmit={handleSubmit} className="space-y-4">
                <div><label className="block text-sm font-medium text-gray-700 mb-2 text-right">الاسم الكامل</label><input type="text" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 text-right" /></div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div><label className="block text-sm font-medium text-gray-700 mb-2 text-right">رقم الهاتف</label><input type="tel" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 text-right" /></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-2 text-right">البريد الإلكتروني</label><input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 text-right" /></div>
                </div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2 text-right">العنوان</label><input type="text" value={formData.address} onChange={(e) => setFormData({...formData, address: e.target.value})} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 text-right" /></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-2 text-right">ملاحظات إضافية</label><textarea value={formData.notes} onChange={(e) => setFormData({...formData, notes: e.target.value})} rows="3" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 text-right" /></div>
                <button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-yellow-500 to-orange-600 hover:from-yellow-600 hover:to-orange-700 text-white font-bold py-4 rounded-lg transition-all disabled:opacity-50">{loading ? 'جاري الإرسال...' : 'تأكيد الطلب'}</button>
              </form></div></div>
              <div className="lg:col-span-1"><div className="bg-white rounded-2xl shadow-xl p-6 sticky top-24"><h3 className="text-xl font-bold text-gray-900 mb-4">ملخص الطلب</h3><div className="space-y-3 mb-6">{cartItems.map(item => (<div key={item.id} className="flex justify-between text-sm"><span>{item.name} x{item.quantity}</span><span className="font-medium">{item.price}</span></div>))}</div><div className="border-t pt-4 mb-6"><div className="flex justify-between text-lg font-bold"><span>الإجمالي:</span><span className="text-yellow-600">${getTotal().toFixed(2)}</span></div></div></div></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Checkout;
